import { Injectable } from '@angular/core';
import { SignalTag } from '../../app/models/SignalTag';
import { Adapter } from '../../app/adapters/Adapter';


@Injectable()
export class SignalTagUtilProvider implements Adapter<SignalTag>{

  adapt(item: any): SignalTag {
    return new SignalTag(item.tagId, item.tagName, item.tagAlias, item.tagDescription, item.engUnits, item.selected);
  }

}



// WEBPACK FOOTER //
// ./src/providers/signal-tag-util/signal-tag-util.ts